
import { Component } from '@angular/core';

@Component({
    selector: 'app-short-trend',
    templateUrl: './short-trend.component.html',
    styleUrls: ['./short-trend.component.css'],
    standalone: false
})
export class ShortTrendComponent {
 
}
